import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import RacesSection from './components/RacesSection';
import StatsSection from './components/StatsSection';
import FeaturesSection from './components/FeaturesSection';
import EventInfoSection from './components/EventInfoSection';
import FaqPage from './components/FaqPage';
import HalfMarathonPage from './components/HalfMarathonPage';
import CtaSection from './components/CtaSection';
import SponsorsSection from './components/SponsorsSection';
import Footer from './components/Footer';
import './App.css';

function HomePage() {
  return (
    <>
      <HeroSection />
      <StatsSection />
      <RacesSection />
      <FeaturesSection />
      <CtaSection />
      <SponsorsSection />
    </>
  );
}

function EventInfoPage() {
  return (
    <>
      <section className="relative min-h-[50vh] sm:min-h-[55vh] flex items-end section-full overflow-hidden">
        <div
          className="absolute inset-0 z-0 md:hidden"
          style={{
            backgroundImage: 'url(/hero-camden-dawn.webp)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/50 to-transparent"></div>
        </div>
        <div
          className="absolute inset-0 z-0 hidden md:block"
          style={{
            backgroundImage: 'url(/hero-camden-scenic-desktop.webp)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/50 to-transparent"></div>
        </div>

        <div className="container-wide relative z-10 pb-12 sm:pb-16">
          <p className="text-white/80 text-sm uppercase tracking-widest font-bold mb-3">Event Info</p>
          <h1 className="display-title text-5xl sm:text-6xl md:text-7xl text-white mb-3">
            EVENT SCHEDULE
          </h1>
          <p className="text-white/85 text-base sm:text-lg max-w-2xl">
            Key timings and race-day details for Sunday 26th July 2026.
          </p>
        </div>
      </section>
      <EventInfoSection showHeading={false} />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/event-info" element={<EventInfoPage />} />
            <Route path="/faq" element={<FaqPage />} />
            <Route path="/half-marathon" element={<HalfMarathonPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
